// extracted by mini-css-extract-plugin
export default {"messageContainer":"NotifyTextarea_messageContainer__YFcen","active":"NotifyTextarea_active__QpUaJ","textarea":"NotifyTextarea_textarea__2WRe1"};